/**
 * An editor shown in a call flow's side panel (docs/41 §5) rather than on its own page: its form
 * takes this id, so the panel's own "Apply to draft" submits it, and what it would have saved goes
 * into the draft instead. The editor's own heading and buttons are left out; everything else -- every
 * field and its help text -- is the same.
 */
export interface PanelMode {
  formId: string;
  onApply: (body: Record<string, unknown>) => void;
}

/** Where the flow last opened is remembered, so another page can send somebody to a particular one. */
export const lastFlowKey = (tenantId: string) => `arc.callflow.${tenantId}`;
